<script>
    import MyLayout from "@/layouts/layout.vue";
    //import { RouterLink, RouterView } from "vue-router";

    import { useloggedUserInfo } from "@/store/UserInfo";
    import GenerateLoanApplication from "@/views/crm/loanapplications/generateloanapplications.vue";
    import Videochat from "@/views/crm/shared/twilio/videochat/videochat.vue";
    import UploadDocument from "@/views/crm/loanapplications/uploaddocument.vue"
    import SignalRService from "@/service/crmservice/signalrservice"
    import { useTerminologyStore } from '@/store/terminologyStore';
    import { isSessionValid, isLoginPath } from '@/helpers/authSession';

    export default {
        components: {
            MyLayout,
            GenerateLoanApplication,
            Videochat,
            UploadDocument,
        },
        //Test
        watch: {
            hasAuthenticatedSession(isAuthenticated) {
                if (isAuthenticated) {
                    this.userId = localStorage.getItem('userId');
                    this.loadPostLoginScripts();
                }
            }
        },
        created() {
            useTerminologyStore().syncFromStorage();
            //if (localStorage.getItem('adminTheme') == 'regularTheme' || localStorage.getItem('adminTheme') == null) {
            //    //import("./assets/css/css/admin.css");
            //    if (document.getElementById('body') != null && document.getElementById('body') != "") {
            //        document.getElementById('body').className = "regularTheme";
            //        document.getElementById("body").classList.remove("light");
            //    }
                

            //} else {
            //    if (document.getElementById('body') != null && document.getElementById('body') != "") {
            //        document.getElementById('body').className = "light";
            //        document.getElementById("body").classList.remove("regularTheme");
            //    }
            //    //import("./assets/css/css/admin-light.css");
            //}
            this.userId = localStorage.getItem("userId");
            const hasAuthenticatedSession = this.hasAuthenticatedSession && !!this.userId;
            // Do not auto-start external/service connections on initial login page load.
            if (hasAuthenticatedSession) {
                this.loadPostLoginScripts();
               // this.hubConnection = this.signalRService.setupSignalR();
                //this.signalRService.hubConnection = this.hubConnection
                //this.startHub();
                //this.reStartHub();
            }
            const store = useloggedUserInfo();
            store.$reset();
            const favicon = document.getElementById("favicon");
            if (favicon != null) {
                favicon.href = 'https://portal.spliyt.com/assets//CompanyImages/defultfavIcon.png';
            }
        },
        methods: {
            loadPostLoginScripts() {
                this.ensureScript(
                    'google-maps-places',
                    'https://maps.googleapis.com/maps/api/js?libraries=places&key=AIzaSyDAxBLp3dCF5scwqQVpji7Ud41-3gtxCHY'
                );
            },
            ensureScript(scriptId, src) {
                if (document.getElementById(scriptId)) {
                    return;
                }
                const script = document.createElement('script');
                script.id = scriptId;
                script.src = src;
                script.async = true;
                script.defer = true;
                document.head.appendChild(script);
            },
            getConnectionId(userId) {
                this.signalRService.GetConnectionId(userId).then(response => {
                    this.connectionId = response.data.connnectionId;
                    localStorage.setItem("connectionId", this.connectionId);
                });
            },
            startHub() {
                if (!this.hubConnection) {
                    return;
                }
                this.hubConnection.start().catch(m => { }).then(m => {
                    this.getConnectionId(this.userId);
                });
            },
            reStartHub() {
                if (!this.hubConnection) {
                    return;
                }
                this.hubConnection.onreconnected(function (conntionId) {
                    this.getConnectionId(this.userId);
                });
            }
        },
        mounted() {
            this.useloggedUserInfo = useloggedUserInfo;
            this.currentPath = window.location.href;
            console.log("this.currentPath", this.currentPath);
        },
        computed: {
            hasAuthenticatedSession() {
                // Re-evaluate when route changes (e.g. post-login $router.push without full reload).
                void this.$route?.fullPath;
                const path = this.$route?.path || '';
                // Never mount authenticated shell on login, even with a stale expired token.
                if (isLoginPath(path)) {
                    return false;
                }
                // Token presence alone is not enough â€” expired JWTs must unmount MyLayout.
                return isSessionValid();
            }
        },
        data() {
            return {
                awesome: false,
                useloggedUserInfo,
                currentPath: window.location.href,
                signalRService: new SignalRService(),
                connectionId: null,
                hubConnection: null,
                userId: null
            };
        },
    };
</script>
<template>
    <section class="page-body">
        <!--<nav>
                <router-link to="/EmployeeAddEdit">Add Employee</router-link> |
                <router-link to="/">List Employee</router-link> |
            </nav>-->

        <template v-if="!currentPath.includes('/application') && !currentPath.includes('/videoChat') && !currentPath.includes('/uploadfiles')">
            <MyLayout v-if="hasAuthenticatedSession" />
            <router-view v-else />
            <DialogsWrapper />
        </template>

        <!-- Show Loan Application Page -->

        <template v-if="currentPath.includes('/application')">
            <GenerateLoanApplication />
        </template>

        <!-- Show video Call Page -->

        <template v-if="currentPath.includes('/videoChat')">
            <div class="container">
                <Videochat />
            </div>
        </template>

        <!-- Upload Loan Document -->

        <template v-if="currentPath.includes('/uploadfiles')">
            <div class="uploadDocument">
                <div class="container">
                    <div class="center-page">
                        <UploadDocument />
                    </div>
                </div>
            </div>
        </template>


    </section>
</template>

<style>
    .uploadDocument {
        background: #b49859;
        border-color: #b49859;
        color: #ffffff;
    }

    .center-page {
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>
